import { render } from "./SvgLogo.vue?vue&type=template&id=8dcfbe96"
import script from "./SvgLogo.vue?vue&type=script&lang=js"
export * from "./SvgLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__